import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import Grid from '@mui/material/Grid';
import StyledTextfield from './StyledTextfield';
import PaperStyled from '../../PaperStyled';
import MyIcon from './MyIcon';

const TransferBandwidth = ({ id, bitRateTotal, md = 12, xs = 12 }) => {
  return (
    <>
      <Grid item md={md} xs={xs}>
        <PaperStyled sx={{ color: 'white', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
          <MyIcon Icon={NetworkCheckIcon} label="Transfer Bandwidth: " />
          <div style={{ marginLeft: '10px', marginBottom: '8px' }}>
            {bitRateTotal * 8} Mbps ({bitRateTotal} MBps)
          </div>
        </PaperStyled>
      </Grid>
    </>
  );
};
export default TransferBandwidth;
